/** Canvas Kingdom — Phase A UI theme constants.
 *  Reference: docs/CLAUDE_CODE_UI_IMPLEMENTATION_BRIEF.md §3.1
 *  CSS variables 版は web/src/style.css :root に定義。本ファイルは TS 側で使う数値定数のみ。
 */

export const THEME_COLORS = {
  sky: '#0798f2',
  skyDeep: '#0472c8',
  skyLight: '#61c6ff',
  grass: '#78d441',
  canvas: '#fff7df',
  panel: '#fff1cf',
  panelEdge: '#7d4a1f',
  gold: '#f7b733',
  goldDark: '#c87412',
  orange: '#ff8a00',
  orangeDark: '#d94f00',
  blue: '#169bf3',
  purple: '#8a3ee8',
  pink: '#ff4f9a',
  green: '#41c65a',
  ink: '#39210f',
  creamText: '#fffaf0',
  danger: '#ff334d',
} as const;

/** Pixi 用 hex(0x…)。Gameplay の描画で使用。 */
export const PIXI_COLORS = {
  canvas: 0xfff7df,
  canvasShadow: 0xf2e6c2,
  orange: 0xff8a00,
  orangeDark: 0xd94f00,
  blue: 0x169bf3,
  purple: 0x8a3ee8,
  pink: 0xff4f9a,
  green: 0x41c65a,
  ink: 0x39210f,
  panelEdge: 0x7d4a1f,
  trailEdge: 0xff6d28,
} as const;

export const FONT_UI =
  '"Arial Rounded MT Bold", "Trebuchet MS", "Noto Sans JP", "Hiragino Sans", system-ui, sans-serif';

export const SCREEN_IDS = ['top', 'home', 'gameplay'] as const;
export type ScreenId = (typeof SCREEN_IDS)[number];
